<template>
    <v-container>
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <v-row class="mt-10">
            <v-col>
<!--                <span class="header bold text-tcdc-green text-uppercase">{{ $t('service.membership') }}</span>-->
                <span class="header bold text-tcdc-green text-uppercase">{{membership[`name_${lang}`]}}</span>
                <Membership />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ServiceExpandable from "../../components/expandables/ServiceExpandable";
    import { mapState } from 'vuex';
    import Membership from "../../components/member_layouts/Membership";

    export default {
        created() {
            this.items[0].text = this.branchName;
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name,
                lang: state => state.Branch.lang,
                membership : state=>{
                    return state.ServiceMenu.membership_main;
                },
            }),
            branchChanged: function () {
                return this.branchName;
            }
        },
        watch: {
            branchChanged: function() {
                this.items[0].text = this.branchChanged;
            }
        },
        data: () => ({
            items: [
                {
                    text: 'TCDC BANGKOK',
                    // disabled: true,
                    // href: "breadcrumbs_dashboard",
                    to: "/home"
                },
                {
                    text: "SERVICE",
                    href: "/service",
                    // to: "/service"
                },
                {
                    text: "MEMBERSHIP",
                    disabled: true,
                    // href: "breadcrumbs_link_1",
                }
            ]
        }),
        components: {
            Membership,
        }
    };
</script>

<style></style>
